import { render, staticRenderFns } from "./Phase2.vue?vue&type=template&id=0a1d9a18&"
import script from "./Phase2.vue?vue&type=script&lang=js&"
export * from "./Phase2.vue?vue&type=script&lang=js&"
import style0 from "./Phase2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Phase2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports